import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import SimplifiedHeader from '../components/SimplifiedHeader'
import Cta from '../components/Cta'
import NotificationBar from '../components/NotificationBar'
import AuthService from '../services/AuthService'
import { useNotification } from '../providers/NotificationProvider';
import useTitle from '../hooks/useTitle'

import {
  useLocation,
  useHistory
} from "react-router-dom";

import LoadingBar from 'react-top-loading-bar';

const queryString = require('query-string');

const VerifyAccountApp = () => {
  useTitle("Verify Account | The Convoy | Save on everyday business expenses.");

  const query = useLocation().search;
  const params = queryString.parse(query);

  const history = useHistory();

  const [ notification, notify ] = useNotification();
  const [ form, setFormData ] = useState({
    code: params.c,
    username: params.u,
  });

  const loadingBarRef = useRef(null);

  useEffect(() => {
    loadingBarRef.current.continuousStart();
    notify({ type: "show_notification", payload: { message: "Verifying Account" }});

    AuthService.verifyAccount(form.code, form.username).then((response) => {
      if (response.data.errors) {
        notify({ type: 'show_notification', payload: { message: response.data.errors.message } });
      } else {
        let verify = response.data.data.verify;
        if (verify.success) {
          notify({ type: 'show_notification', payload: { message: "Account Verified!" } });
          history.push('/login');
        } else {
          notify({ type: 'show_error', payload: { message: verify.message } });
        }
      }

      loadingBarRef.current.complete();
    });
  }, []);
  return (
    <div className="bg-white">
      <LoadingBar color='#0173FF' ref={loadingBarRef} />
      <SimplifiedHeader showLogin="true" />
      <NotificationBar />
  
      <div className="containter bg-white">
        <div className="hidden max-w-5xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <div className="flex flex-wrap">
              <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                <span className="font-header text-title-mobile md:text-title block">Verify Account</span>
              </h2>
          </div>

        </div>
      </div>
    </div>
  )
}

export default VerifyAccountApp;
